import { render } from "./editDealerForm.vue?vue&type=template&id=5fef6e9c&scoped=true"
import script from "./editDealerForm.vue?vue&type=script&lang=js"
export * from "./editDealerForm.vue?vue&type=script&lang=js"

import "./editDealerForm.vue?vue&type=style&index=0&id=5fef6e9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fef6e9c"]])

export default __exports__